/**
 * DEPRECATED chat component delete with pom 12.0.0 && delete files .ftl 
 */
(function () {
    'use strict';

    var ItxChatOldCmp = {
        controller: ItxChatOldCmpCtrl,
        template: ''
    };

    ItxChatOldCmpCtrl.$inject = [];

    function ItxChatOldCmpCtrl() {
        var _this = this;
        _this.$onInit = function () {};
    }

    angular.module('itxApp.common').component('itxChat', ItxChatOldCmp);
})();
